// ==============================|| LANDING - FOOTER PAGE ||============================== //

import { Stack } from '@mui/material';
import { Box } from '@mui/system';

type showProps = {
  isFull?: boolean;
};

const FooterBlock = ({ isFull }: showProps) => {
  const year = new Date().getFullYear();

  return (
    <Box sx={{ height: '200px', backgroundColor: '#417175', color: '#fbc849', textAlign: 'center', fontSize: '10px' }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        height="5vh"
        // divider={<Divider sx={{ mt: 3, mb: 3 }} orientation="vertical" flexItem />}
        spacing={5}
      >
        <div>© {year}</div>
      </Stack>
      {/* [LANDING FOOTER] */}
    </Box>
  );
};

export default FooterBlock;
